import View from '@/components/common/view'
import TraineeEmployerIndex from '../components/zhihuanbao/Index';

export default [
	{
		path:'',
		component:TraineeEmployerIndex,
	},
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/zhihuanbao.js